import { render, staticRenderFns } from "./JielvModuleNav.vue?vue&type=template&id=db7b3ffa&scoped=true"
import script from "./JielvModuleNav.vue?vue&type=script&lang=js"
export * from "./JielvModuleNav.vue?vue&type=script&lang=js"
import style0 from "./JielvModuleNav.vue?vue&type=style&index=0&id=db7b3ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7b3ffa",
  null
  
)

export default component.exports